// src/contexts/AssessmentContext.jsx
import React, { createContext, useContext } from 'react';
import { useAssessment } from '../hooks/useAssessment';

/**
 * AssessmentContext wraps all run-time assessment state that the
 * application needs. Assessment discovery is deliberately performed by the
 * exact-user, server-scoped catalog call in AssessmentLogin; no hard-coded
 * list is exposed as a second source of truth.
 */
const AssessmentContext = createContext(null);

export function AssessmentProvider({ children }) {
  /* core runtime state (big bundle) */
  const assessment = useAssessment();

  return (
    <AssessmentContext.Provider value={assessment}>
      {children}
    </AssessmentContext.Provider>
  );
}

export function useAssessmentContext() {
  const context = useContext(AssessmentContext);
  if (!context) {
    throw new Error(
      'useAssessmentContext must be used within an AssessmentProvider'
    );
  }
  return context;
}
